// extracted by mini-css-extract-plugin
export var layout = "Layout_layout__+nPRX";
export var legacyDashboard = "Layout_legacyDashboard__fJheN";
export var service = "Layout_service__qYw8Z";